import axios from "axios";
import { useEffect, useState } from "react";
import { toast, Bounce } from "react-toastify";
import { useAudio, useAudioList } from "../Stores/useAudio";
import { AFCASOWRow } from "../AFCASOWRow";
import { DeclinedClaimRow } from "../DeclinedClaimRow";
import { EggHatchedRow } from "../EggHatchedRow";
import { CashSettlementRow } from "../CashSettlementRow";
import { useDispatch, useSelector } from "react-redux";


import {
  getClaims,
  partiallyApproved,
  decideClaim,
  fullyApproved,
  fullDenial,
  deleteClaim
} from "../../action";

export const SOWRow = ({
  address,
  description,
  index,
  claimantId,
  claimantName,
  insurer,
  status,
  sowReqSentTime,
  buttonstatus,
  afcaWonDate,
  timestamps
}) => {
  const jwtToken = localStorage.getItem("jwtToken");
  const [leftHours, setLeftHours] = useState(100);
  const [progress, setProgress] = useState(0);

  const { setAudioURL } = useAudio();
  const { afcaAudios } = useAudioList();
  const [modalOpen, setModalOpen] = useState(false);
  const [firstAnswer, setFirstAnswer] = useState("");
  const [secondAnswer, setSecondAnswer] = useState("");
  const [sowMessage, setSowMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [isSowRequestModal, setIsSowRequestModal] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dispatch = useDispatch();
  const state = useSelector((state) => state.reducer);
  const [isShow, setIsShow] = useState(true);
  const [afcaWonFianlDate, setAfcaWonFinalDate] = useState("");
  const [open, setOpen] = useState(false);

  // useEffect(() => {
    
  // }, [])
  const keys = timestamps ? Object.keys(timestamps).sort((a, b) => new Date(timestamps[a]) - new Date(timestamps[b])) : [];
  const results = keys.map((key) => {
    const currentDate = new Date(timestamps[key]);
    const today = new Date();
    const diffTime = Math.abs(today - currentDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return { timestamp: key, daysAgo: diffDays };
  });

  useEffect(() => {
    const start = new Date(sowReqSentTime);
    const end = new Date(start);
    end.setHours(start.getHours() + 72);
    const now = new Date();

    const totalHours = (end.getTime() - start.getTime()) / (1000 * 60 * 60);
    const elapsedHours = (now.getTime() - start.getTime()) / (1000 * 60 * 60);
    const remainingHours = Math.max(totalHours - elapsedHours, 0);

    setLeftHours(Math.ceil(remainingHours));
    setProgress(Math.min((elapsedHours / totalHours) * 100, 100));
    setIsDisabled(buttonstatus);
    if (leftHours === 0) {
      setIsDisabled(false);
    }
  }, [sowReqSentTime, leftHours, buttonstatus]);
  useEffect(() => {
    if (afcaWonDate) {
      const dateObj = new Date(afcaWonDate);
      const today = new Date();
      const afcaDateOnly = new Date(dateObj.toDateString());
      const todayDateOnly = new Date(today.toDateString());
      const diffTime = todayDateOnly - afcaDateOnly;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      setAfcaWonFinalDate(diffDays);
    }
  }, [afcaWonDate]);
  let total = 0;
  state.claimsData?.forEach(claim => {
    if (claim.addedAFCASowId === claimantId) {
      if (claim.status === "AFCA SOW") total++;
      if (claim.status === "Cash Settlement") total++;
      if (claim.status === "Variation") total++;
      if (claim.status === "Claim Declined") total++;
    }
  });
  

  const handleEmail = () => {
    const formData = new FormData();
    const pdfFile = document.getElementById(claimantId).files[0];
    formData.append("pdf", pdfFile);
    buttonstatus
      ? formData.append("recipient", "accounts@dragonroofrestoration.com")
      : formData.append("recipient", "accounts@dragonroofrestoration.com");
    formData.append("subject", "SOW Request Submitted with Attachment");
    formData.append("message", sowMessage);
    axios
      .post(
        `https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/send-email`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        if (res.data.message) {
          toast.success(res.data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          dispatch({ type: "SET_BADGE_GIFT", payload: `successfully sent mail!` })
          dispatch(getClaims());
          setAudioURL(afcaAudios);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <tr key={index} className="border-t">
        <td className="px-6 py-4 text-center">{address}</td>
        <td className="px-6 py-4 text-center">{claimantName}</td>
        <td className="px-6 py-4 text-center">{insurer}</td>
        <td className="px-6 py-4 text-center">{description}</td>
        <td className="px-6 py-4 text-center relative">
          <div
            className="bg-blue-50 hover:bg-blue-100 px-2 py-1 border border-blue-100 rounded-2xl w-max mx-auto text-blue-700 cursor-pointer"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
          >
            {status}
            {open && (
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 bg-white shadow-lg rounded-xl p-4 w-56 z-10 text-sm">
                {results?.map((item, idx) => (
                  <div key={idx} className="mb-2">
                    <strong>{
                      item.timestamp === "createdAt" ? "Authorized" :   
                      item.timestamp === "assessmentStart" ? "Under Assessment" :
                      item.timestamp === "appealStart" ? "Appeal in Progress" :
                      item.timestamp === "afcaWonDate" ? "Scope of Works" :
                      item.timestamp === "cashSettlementDate" ? "Cash Settlement" :
                      item.timestamp === "eggHatchedDate" ? "Egg Hatched" :
                      item.timestamp === "afcaAppealMadeDate" ? "AFCA Appeal" :
                      item.timestamp === "afcaAppealMadeDate" ? "AFCA Appeal" :
                      item.timestamp === "declinedDate" ? "AFCA Claim Denied" : ""
                    }</strong>: {item.daysAgo} day{item.daysAgo !== 1 && 's'}
                  </div>
                ))}
              </div>
            )}
          </div>
        </td>
        <td className="px-6 py-4 text-center">
          {sowReqSentTime !== undefined ? (
            <div className="flex flex-col gap-y-1">
              <div className="flex justify-between text-xs">
                <p>{`${leftHours} hours left`}</p>
              </div>
              <div className="bg-gray-200 dark:bg-gray-200 rounded-full w-full h-2.5">
                <div
                  className="bg-blue-500 rounded-full h-2.5"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <div className="flex justify-between text-xs">
                <p>Start</p>
                <p>72 hours</p>
              </div>
            </div>
          ) : null}
        </td>
        <td className="px-6 py-4 text-center">
          {
            state.role === 0 ? (
            <div className="flex flex-col w-full text-center font-semibold relative">
              <input
                type="file"
                id={claimantId}
                accept=".pdf"
                className="hidden"
                onChange={(e) => {
                  if (e.target.files.length > 0) {
                    handleEmail();
                  }
                }}
              />

              {/* Dropdown Trigger Button - Maintains original style */}
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="relative w-full px-4 py-2 rounded-md text-sm font-medium bg-gradient-to-br from-blue-500 to-blue-700 shadow-lg hover:scale-105 hover:from-blue-600 hover:to-blue-800 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow"
              >
                <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                <span className="relative z-10 text-white flex items-center justify-between">
                  Actions
                  <svg
                    className={`w-4 h-4 ml-2 transition-transform ${isDropdownOpen ? "rotate-180" : ""}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </span>
              </button>
              

              {/* Dropdown Menu with original button styles */}
              {isDropdownOpen && (
                <div className="absolute top-full left-0 mt-1 w-full rounded-md shadow-lg z-10 bg-white border border-gray-200 overflow-hidden">
                  <div className="space-y-1 p-1">
                    <button
                      className={`relative w-full px-4 py-2 rounded-md text-sm font-medium bg-gradient-to-br from-green-400 to-green-600 shadow-lg hover:scale-105 hover:from-green-500 hover:to-green-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow ${
                        isDisabled ? "cursor-not-allowed opacity-40" : ""
                      }`}
                      onClick={() => {
                        setIsSowRequestModal(true);
                        setIsDropdownOpen(false);
                      }}
                      disabled={isDisabled}
                    >
                      <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                      <span className="relative z-10 text-white">Send SOW Request</span>
                    </button>

                    <button
                      className="relative w-full px-4 py-2 rounded-md text-sm font-medium bg-gradient-to-br from-red-400 to-red-600 shadow-lg hover:scale-105 hover:from-red-500 hover:to-red-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow"
                      onClick={() => {
                        setModalOpen(true);
                        setIsDropdownOpen(false);
                      }}
                    >
                      <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                      <span className="relative z-10 text-white">Variation</span>
                    </button>

                    <button
                      className="relative w-full px-4 py-2 rounded-md text-sm font-medium bg-gradient-to-br from-emerald-400 to-emerald-600 shadow-lg hover:scale-105 hover:from-emerald-500 hover:to-emerald-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow"
                      onClick={() => {
                        dispatch(fullyApproved(claimantId, "fullyApproved"));
                        setIsDropdownOpen(false);
                      }}
                    >
                      <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                      <span className="relative z-10 text-white">Fully Approved</span>
                    </button>

                    <button
                      className="relative w-full px-4 py-2 rounded-md text-sm font-medium bg-gradient-to-br from-yellow-400 to-orange-600 shadow-lg hover:scale-105 hover:from-yellow-500 hover:to-orange-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow"
                      onClick={() => {
                        dispatch(decideClaim(claimantId, "approvedUndo", jwtToken));
                        setIsDropdownOpen(false);
                      }}
                    >
                      <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                      <span className="relative z-10 text-white">Undo</span>
                    </button>
                  </div>
                </div>
              )}

              {/* Modals (unchanged from your original code) */}
              <div
                className={`fixed left-0 top-0 flex h-full min-h-screen w-full items-center justify-center bg-dark/90 px-4 py-5 ${
                  modalOpen ? "block" : "hidden"
                }`}
              >
                <div className="flex flex-col gap-y-4 bg-white dark:bg-dark-2 shadow-xl p-4 rounded-[20px] w-full max-w-[570px] text-center">
                  <div className="w-full bg-white rounded-lg overflow-hidden">
                    <form className="px-6 py-4">
                      <div className="mb-6">
                        <label className="flex text-sm font-medium text-gray-700 mb-2">
                          What line items are being contested?
                        </label>
                        <textarea
                          className="p-2 border w-full"
                          onChange={(e) => setFirstAnswer(e.target.value)}
                        />
                      </div>
                      <div className="flex justify-end space-x-2 mt-6">
                        <button
                          type="button"
                          className="px-4 py-2 bg-white text-gray-700 font-medium rounded-md border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                          onClick={() => setModalOpen(false)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="px-4 py-2 bg-red-600 text-white font-medium rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                          onClick={() => {
                            setModalOpen(false);
                            dispatch(
                              partiallyApproved(
                                claimantId,
                                firstAnswer,
                                secondAnswer,
                                jwtToken
                              )
                            );
                          }}
                        >
                          Okay
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div
                className={`fixed left-0 top-0 flex h-full min-h-screen w-full items-center justify-center bg-dark/90 px-4 py-5 ${
                  isSowRequestModal ? "block" : "hidden"
                }`}
              >
                <div className="flex flex-col gap-y-4 bg-white dark:bg-dark-2 shadow-xl p-4 rounded-[20px] w-full max-w-[570px] text-center">
                  <div className="w-full bg-white rounded-lg overflow-hidden">
                    <form className="px-6 py-4">
                      <div className="mb-6">
                        <label className="flex text-sm font-medium text-gray-700 mb-2">
                          Send Message to accounts@dragonroofrestoration.com
                        </label>
                        <textarea
                          className="p-2 border w-full"
                          onChange={(e) => setSowMessage(e.target.value)}
                        />
                      </div>
                      <div className="flex justify-end space-x-2 mt-6">
                        <button
                          type="button"
                          className="px-4 py-2 bg-white text-gray-700 font-medium rounded-md border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                          onClick={() => setIsSowRequestModal(false)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="px-4 py-2 bg-red-600 text-white font-medium rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                          onClick={() => {
                            document.getElementById(claimantId).click();
                            setIsSowRequestModal(false);
                          }}
                        >
                          Attach PDF
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            ) : (
              <button
                onClick={(e) => dispatch(deleteClaim(claimantId, state.currentUserName))}
                className="relative px-5 py-2  tracking-wide text-white uppercase rounded-lg bg-gradient-to-br from-red-400 to-red-600 shadow-lg transition duration-300 ease-in-out transform hover:scale-105 hover:from-red-500 hover:to-red-700 hover:shadow-2xl active:scale-95 animate-pulse-glow"
              >
                <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                <span className="relative z-10">Delete</span>
              </button>
            )
          }
          {
            total > 0 && (
              <button
                className={`relative w-full mt-2 px-4 py-2 rounded-md text-sm font-medium bg-gradient-to-br from-green-400 to-green-600 shadow-lg hover:scale-105 hover:from-green-500 hover:to-green-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow ${
                  isDisabled ? "cursor-not-allowed opacity-40" : ""
                }`}
                onClick={() => {
                  setIsShow(!isShow)
                }}
              >
                <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                <span className="relative z-10 text-white">{isShow ? "hide" : "show"}</span>
              </button>
            )
          }
          
        </td>
        <td className="text-center">
          {
            afcaWonFianlDate === 0 ? "Today" : (`staying for ${afcaWonFianlDate} days`)
          }
        </td>
      </tr>
      { isShow &&
        state.claimsData?.map((claim, index) => {
          return claim.addedAFCASowId === claimantId && claim.status === "AFCA SOW" ?
          (
            <tr>
                <AFCASOWRow
                  address={claim.address}
                  description={claim.description}
                  key={index}
                  index={0}
                  claimantId={claim._id}
                  claimantName={claim.claimantName}
                  insurer={claim.insurerName}
                  status={claim.status}
                  sowStarttime={claim.timers.afcaSOWsentDate}
                  firstQuiz={claim.partiallyApprovedQuestions.firstQuiz}
                  secondQuiz={claim.partiallyApprovedQuestions.secondQuiz}
                  type={2}
                />
            </tr>
          ) : claim.addedAFCASowId === claimantId && claim.status === "Cash Settlement" ? 
          (
            <tr>
              <CashSettlementRow
                address={claim.address}
                description={claim.description}
                key={index}
                index={0}
                claimantId={claim._id}
                claimantName={claim.claimantName}
                insurer={claim.insurerName}
                status={claim.status}
                type={2}
                firstQuiz={claim.partiallyApprovedQuestions.firstQuiz}
                cashStartTime={claim.timestamps.cashSettlementDate}
              />
            </tr>
          ) : claim.addedAFCASowId === claimantId && claim.status === "Variation" ? 
          (
            <tr>
              <EggHatchedRow
                address={claim.address}
                description={claim.description}
                key={index}
                index={0}
                claimantId={claim._id}
                claimantName={claim.claimantName}
                insurer={claim.insurerName}
                status={claim.status}
                eggHatchedDate={claim.timestamps.eggHatchedDate}
                choise={claim.cashSettlement.settlementChoice}
                type={2}
                firstQuiz={claim.partiallyApprovedQuestions.firstQuiz}
              />
            </tr>
          ) : claim.addedAFCASowId === claimantId && claim.status === "Child Claim Declined" ? 
          (
            <tr>
              <DeclinedClaimRow
                address={claim.address}
                description={claim.description}
                key={index}
                index={0}
                claimantId={claim._id}
                claimantName={claim.claimantName}
                insurer={claim.insurerName}
                status={claim.status}
                declinedDate={claim.timestamps.declinedDate}
                type={2}
              />
            </tr>
          ) : null
        })
      }
    </>
  );
};